export const DAILY = 'daily'
export const WEEKLY = 'weekly'
export const SHIFT = 'shift'
export const VISIT = 'visit'
export const FLEXIBLE = 'flexible'
export const USER = 'user'
export const RESIDENT = 'resident'
